export interface ExternalBillingItemDto {
    id: number;
    licenseModuleId: number;
    agreementNumber: number;
    registeredDate: Date;
    deregisteredDate?: Date;
    billingText: string;
    discountPercentage?: number;
    discountExpiry?: Date;
    externalId: string;
}

export enum LicenseModuleAddon {
    None = 0,
    Rackbeat = 83,
    Budget123 = 96,
}
